export class DocumentoTicket {
    id: number;
    nombre_fisico: string;
    nombre_logico: string;
    incidencia_id: number;

    constructor() {
        this.nombre_fisico = '';
        this.nombre_logico = '';
        this.incidencia_id = -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/modelos/documento_ticket.ts